/* istanbul ignore file */
import { Component, Input, Output, EventEmitter, inject } from '@angular/core';
import { IContract, IFamilyMember } from 'src/app/model/contract/IContract';
import { UserClaims } from 'src/app/model/okta/userClaims';
import { ADPResourceService } from 'digital-core';

@Component({
  selector: 'pgh-family-member-card',
  templateUrl: './family-member-card.component.html',
  styleUrls: ['./family-member-card.component.scss'],
})
export class FamilyMemberCardComponent {
  @Input() familyMember: IFamilyMember;
  @Input() user: UserClaims;
  @Input() contract: IContract;

  @Output() editAction = new EventEmitter();
  @Output() changeAvatarAction = new EventEmitter();
  @Output() deleteAction = new EventEmitter();
  resourceService = inject(ADPResourceService);

  get canEdit() {
    return this.familyMember.emailAddress?.toLowerCase() !== this.contract.primaryUserEmail?.toLowerCase();
  }

  get canChangeAvatar() {
    return (
      this.contract.primaryUserEmail?.toLowerCase() === this.user.email?.toLowerCase() ||
      this.familyMember.emailAddress?.toLowerCase() === this.user.email?.toLowerCase()
    );
  }

  get canDelete() {
    return (
      this.familyMember.emailAddress?.toLowerCase() !== this.contract.primaryUserEmail?.toLowerCase() &&
      this.contract.primaryUserEmail?.toLowerCase() === this.user.email?.toLowerCase()
    );
  }

  onEditClicked() {
    this.editAction.emit(this.familyMember);
  }

  onChangeAvatarClicked() {
    this.changeAvatarAction.emit(this.familyMember);
  }

  onDeleteClicked() {
    this.deleteAction.emit(this.familyMember);
  }

  getViewLabel(item: string) {
    const label = this.resourceService.getViewLabel(item) ?? '';
    return this.resourceService.transformContentData(label);
  }
}
